import { render, staticRenderFns } from "./driverAuditDetail.vue?vue&type=template&id=23d8ffb0&scoped=true"
import script from "./driverAuditDetail.vue?vue&type=script&lang=js"
export * from "./driverAuditDetail.vue?vue&type=script&lang=js"
import style0 from "./driverAuditDetail.vue?vue&type=style&index=0&id=23d8ffb0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d8ffb0",
  null
  
)

export default component.exports